import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { RoundWhitePlain, RoundBluePlain } from "components/ui/Buttons/generic/GenericButton";
import { forwardRef, useEffect, useRef, useState } from "react";
import arrowInCircle from "../arrow-in-circle.svg";
import '../styles/additional.css';
import Edit from '../edit.svg';
import Account from '../account_circle.svg';
import AccountW from '../account_circle-w.svg';
import { Link } from "react-router-dom";
import CATEGS from '../assets/categs.json';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
};


export default function Services(){
    useEffect(()=> {
        document.title= "Nos prestations entreprises - Wall of Share";
        const desc= "Découvrez nos prestations pour entreprises, incluant développement, design, rédaction et plus, avec des freelances qualifiés pour mener à bien vos projets.";
        setDescription(desc);
    }, []);

    const headerBanner= useRef<HTMLDivElement>(null);
    const stickyButtons= useRef<HTMLDivElement>(null);

    const [isButtonBlue, setIsButtonBlue]= useState(false);

    const checkCollisionBetweenHeaderAndStickyButtons= () => {
        const stickyPos= stickyButtons.current?.getBoundingClientRect().bottom;
        const headerBannerPos= headerBanner.current?.getBoundingClientRect().bottom;


        if ((stickyPos && headerBannerPos) && (stickyPos <= headerBannerPos)) {
            setIsButtonBlue(false);
        } else {
            setIsButtonBlue(true);
        }
    };

    useEffect(()=> {
        checkCollisionBetweenHeaderAndStickyButtons();
        window.addEventListener('scroll', checkCollisionBetweenHeaderAndStickyButtons);
        return () => {
            window.removeEventListener('scroll', checkCollisionBetweenHeaderAndStickyButtons);
        };
    }, []);
    
    useGSAP(()=>{
        gsap.from(".cat-fade-x", {
            x: 70,
            duration: 1,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".cat-fade-x",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
        gsap.from(".cat-fade-y", {
            y: 70,
            duration: 1,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".cat-fade-y",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
        gsap.from(".cat-fade-scale", {
            scale: 0.98,
            duration: 0.6,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".cat-fade-scale",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
    }, []);

	return (
		<>
			<Header type="default" />
            <div className="w-full relative">
                <div className="h-0 sticky top-[39px] right-[30px] z-[5] max-w-[1900px] mx-auto">
                    <FloatingButtons blue={isButtonBlue} ref={stickyButtons}/>
                </div>
                <HeaderBanner ref={headerBanner}/>
                <CommentCa />
                <CallToAction isFreelance={true}/>
                <FooterMaximized />
            </div>
		</>
	);
}

const HeaderBanner= forwardRef(function HeaderBanner(props: any, ref: any) {
	return(
	<>
		<div className="py-[120px] relative bg-[#1d1d39] flex flex-col gap-[27px] items-center overflow-hidden w-full" ref={ref}>
			<div className="w-full absolute z-1 categ-banner-bg">
				<img src="/comment-ca/comment-ca-marche-banner.webp" className="w-full" />
			</div>
			<h1 className="text-[30px] leading-[30px] md:text-[60px] md:leading-[60px] font-semibold text-white relative z-2" >Nos catégories</h1>
			<p className="md:text-[22px] md:leading-[28.64px] text-[16px] leading-[20.83px] text-[#bbbbc4] text-center font-normal font-dm-sans max-w-[min(1012px_,_90vw)] mx-auto relative z-2">Explorez nos catégories et trouvez des talents ou des missions sur mesure, adaptés à vos besoins dans divers domaines professionnels.</p>
			<div className="max-w-[min(1160px_,_95vw)] mx-auto xl:gap-[40px] lg:gap-[20px] gap-[40px] grid lg:grid-cols-2 grid-cols-1 lg:mt-[80px] md:mt-[60px] mt-[30px] relative z-2" >
				{
					CATEGS.map((categ: typeof CATEGS[0], index: number)=>(
						<CategCard title={categ.title} imagePath={categ.bgIm} key={"categ-" + index} linkUrl={categ.url}/>
					))
				}
			</div>
		</div>
	</>
	);
});

const FloatingButtons= forwardRef(function FloatingButtons(props : any, ref: any) {
    const PkEnter= useRef<HTMLAnchorElement>(null);
    const LdEnter= useRef<HTMLAnchorElement>(null);
    const sticky1= useRef<HTMLDivElement>(null);
    const sticky2= useRef<HTMLDivElement>(null);

    const blue= props.blue;
	const toggleExpanded= (event: any) => {
		event.preventDefault();
        if(event.currentTarget.classList.contains('expanded')){
            if(event.currentTarget.getAttribute('data-target')=== '1'){
                goToPk(event);
            } else if (event.currentTarget.getAttribute('data-target')=== '2'){
                goToLd(event);
            }
        }
		event.currentTarget.classList.toggle('expanded');
	};

    const goToPk= (event: any) => {
        event.preventDefault();
        PkEnter.current?.click();
    };

    const goToLd= (event: any) => {
        event.preventDefault();
        LdEnter.current?.click();
    };

    useEffect(()=>{
        const unExpand= (event: any) => {
            if(!event.target.closest('div[data-target="1"]')){
                sticky1.current?.classList.remove('expanded');
            } else {
                setTimeout(()=>{
                    sticky1.current?.classList.remove('expanded');
                }, 3000);
            }
            if(!event.target.closest('div[data-target="2"]')){
                sticky2.current?.classList.remove('expanded');
            } else {
                setTimeout(()=>{
                    sticky2.current?.classList.remove('expanded');
                }, 3000);
            }

        };
        document.body.addEventListener("click", unExpand);
        return(()=>{
            document.body.removeEventListener("click", unExpand);
        });
    }, []);

	return(
	<>
        <div className="absolute top-[39px] right-[30px] z-2" ref={ref}>
            <div className="lg:flex flex-col items-end gap-[18px] floating-buttons hidden">
                <div className="bg-gradient-to-r from-purple-500 via-red-500 to-orange-500 text-white text-[18px] leading-[21.6px] font-semibold rounded-[20px] floating-button" onClick={goToPk}>
                    <div className=" px-[20px] py-[20px] floating-text">
                        Publier votre Projet
                    </div>
                    <div className="bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon on-top">
                        <img src={Edit} alt="contract-edit"/>
                    </div>
                </div>
                    
                <div className={blue? "bg-primary-blue text-[18px] leading-[21.6px] font-semibold rounded-[20px] text-white floating-button" : "bg-white text-[18px] leading-[21.6px] font-semibold rounded-[20px] text-primary-blue floating-button"} onClick={goToLd}>
                    <div className=" px-[20px] py-[20px] floating-text">
                        Inscrivez-vous
                    </div>
                    <div className={!blue ? "bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon" : "bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon on-top"}>
                        <img src={AccountW} alt="contract-edit"/>
                    </div>
                    <div className={blue ? "bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon" : "bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon on-top"}>
                        <img src={Account} alt="contract-edit"/>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-end gap-[18px] floating-buttons lg:hidden" >
                <div className="bg-gradient-to-r from-purple-500 via-red-500 to-orange-500 text-white text-[13px] leading-[15.6px] font-semibold rounded-[10px] mobile-floating-button" onClick={toggleExpanded} data-target="1" ref={sticky1}>
                    <div className=" px-[10.5px] py-[10.5px] floating-text">
                        Publier votre Projet
                    </div>
                    <div className="bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon on-top">
                        <img src={Edit} alt="contract-edit"/>
                    </div>
                </div>
                    
                <div className={blue? "bg-primary-blue text-white text-[13px] leading-[15.6px] font-semibold rounded-[10px] mobile-floating-button" : "bg-white text-[13px] text-primary-blue leading-[15.6px] font-semibold rounded-[10px] mobile-floating-button"} onClick={toggleExpanded} data-target="2" ref={sticky2}>
                    <div className=" px-[10.5px] py-[10.5px] floating-text">
                        Inscrivez-vous
                    </div>
                    <div className={!blue ? "bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon" : "bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon on-top"}>
                        <img src={AccountW} alt="contract-edit"/>
                    </div>
                    <div className={blue ? "bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon" : "bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon on-top"}>
                        <img src={Account} alt="contract-edit"/>
                    </div>
                </div>
            </div>
        </div>
        <Link to="/parcours-entreprise" className="hidden" aria-hidden="true" ref={PkEnter} />
        <Link to="/inscription-entreprises" className="hidden" aria-hidden="true" ref={LdEnter} />
	</>
	);
});

const OldFloatingButtons= forwardRef(function FloatingButtons(props : any, ref: any) {
    const blue= props.blue;
	const toggleExpanded= (event: any) => {
		event.preventDefault();
		event.currentTarget.classList.toggle('expanded');
	};
	return(
	<>
        <div className="absolute top-[39px] right-[30px] z-2" ref={ref}>
            <div className="lg:flex flex-col items-end gap-[18px] floating-buttons hidden">
                <div className="bg-gradient-to-r from-purple-500 via-red-500 to-orange-500 text-white text-[18px] leading-[21.6px] font-semibold rounded-[20px] floating-button">
                    <div className=" px-[20px] py-[20px] floating-text">
                        Publier votre Projet
                    </div>
                    <div className="bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon">
                        <img src={Edit} alt="contract-edit"/>
                    </div>
                </div>
                {
                    blue ?
                    <div className="bg-primary-blue text-[18px] leading-[21.6px] font-semibold rounded-[20px] text-white floating-button">
                        <div className=" px-[20px] py-[20px] floating-text">
                            Inscrivez-vous
                        </div>
                        <div className="bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon">
                            <img src={AccountW} alt="contract-edit"/>
                        </div>
                    </div>
                    :
                    <div className="bg-white text-[18px] leading-[21.6px] font-semibold rounded-[20px] text-primary-blue floating-button">
                        <div className=" px-[20px] py-[20px] floating-text">
                            Inscrivez-vous
                        </div>
                        <div className="bg-transparent px-[20px] py-[20px] rounded-[20px] floating-icon">
                            <img src={Account} alt="contract-edit"/>
                        </div>
                    </div>
                }
            </div>
            <div className="flex flex-col items-end gap-[18px] floating-buttons lg:hidden" >
                <div className="bg-gradient-to-r from-purple-500 via-red-500 to-orange-500 text-white text-[13px] leading-[15.6px] font-semibold rounded-[10px] mobile-floating-button" onClick={toggleExpanded}>
                    <div className=" px-[10.5px] py-[10.5px] floating-text">
                        Publier votre Projet
                    </div>
                    <div className="bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon">
                        <img src={Edit} alt="contract-edit"/>
                    </div>
                </div>
                {
                    blue ?
                    <div className="bg-primary-blue text-[13px] leading-[15.6px] font-semibold rounded-[10px] text-white mobile-floating-button" onClick={toggleExpanded}>
                        <div className=" px-[10.5px] py-[10.5px] floating-text">
                            Inscrivez-vous
                        </div>
                        <div className="bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon">
                            <img src={AccountW} alt="contract-edit"/>
                        </div>
                    </div>
                    :
                    <div className="bg-white text-[13px] leading-[15.6px] font-semibold rounded-[10px] text-primary-blue mobile-floating-button" onClick={toggleExpanded}>
                        <div className=" px-[10.5px] py-[10.5px] floating-text">
                            Inscrivez-vous
                        </div>
                        <div className="bg-transparent px-[10.5px] py-[10.5px] rounded-[10px] floating-icon">
                            <img src={Account} alt="contract-edit"/>
                        </div>
                    </div>
                }
            </div>
        </div>
	</>
	);
});

const CategCard= ({title, imagePath, linkUrl}: {title: string, imagePath: string, linkUrl: string}) => {
    const subcateglink= useRef<HTMLAnchorElement>(null);
    const clickLink= (event: any) => {
        event.stopPropagation();
        if(subcateglink.current){
            subcateglink.current.click();
        }
    };
	return (
		<div className="categ-card rounded-[20px] overflow-hidden grid md:grid-cols-[175px_1fr] grid-cols-[100px_1.5fr] max-w-[min(90vw_,_560px)] cursor-pointer cat-fade-scale" onClick={clickLink}>
            <Link to={linkUrl} className="hidden" ref={subcateglink} ></Link>
			<div className="categ-card-im bg-cover bg-center bg-norepeat w-full" style={{backgroundImage: `url('${imagePath}')`}}></div>
			<div className="[@media(max-width:385px)]:px-[20px] px-[30px] md:p-[40px] xl:px-[40px] lg:px-[20px] px-[20px] py-[20px] flex flex-row items-center justify-between bg-[#f4f4f522] gap-[15px]" >
				<div className="md:text-[25px] text-white md:leading-[30px] text-[18px] leading-[21.6px] font-semibold md:max-w-[230px] max-w-[175px]">{title}</div>
				<img src={arrowInCircle} alt="ARR_IN_C" className="categ-card-arrow [@media(max-width:400px)]:hidden block"/>
			</div>
		</div>
	);
};


const CommentCa= () => {
    const type= "freelance";
    return (
		<div className={`${type !== 'freelance' ? 'bg-[#F4F4F5]' : ''}  py-[140px] relative flex flex-col items-center gap-[40px] relative`}>
			<div className='lg:w-[76%] lg:px-0 px-8 mx-auto max-w-[1152px] lg:min-w-[1000px]'>
				<CommentCaEnTete type={type} />
				<CommentCaSteps type={type} />
			</div>
			<RoundWhitePlain text="Inscrivez-vous maintenant" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" isButton={false} to={"/inscription"} />
		</div>
	);
};

export const CommentCaEnTete= ({type}: any) => {
    return (<>
        <div className=' text-center text-primary-blue font-semibold  text-[30px] leading-[36px] md:text-[40px] md:leading-[48px] mb-[.7em]'>
            <div>Comment ça marche ?</div>
        </div>

        <div className='text-[#6F6F6F] text-center font-normal font-dm-sans my-[1rem] md:text-[22px] md:leading-[28.64px] text-[16px] leading-[20.83px] lg:w-4/5 mx-auto'>
            {
                type === 'non-default' ?
                    (
                        <>Découvrez un processus simple et rapide pour trouver les meilleurs talents et gérer vos projets en toute sérénité, de la publication de votre mission à sa réalisation.</>
                    ) :
                    (
                        <>Suivez ces étapes simples pour recruter ou vous démarquer en tant que freelance, et accédez à des missions ou des talents de qualité sur Wall-of-Share.</>
                    )
            }
        </div>
    </>
    );
};

export const CommentCaSteps= ({type}: any) => {
    return (
        <>
            <div className='lg:grid grid-cols-3 space-y-8 lg:space-y-0 gap-x-6 mt-8 flex flex-col items-center'>
                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full cat-fade-x`}>
                    <div className='w-max bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold'>O1</div>
                    <div className='font-bold text-primary-blue text-[20px] leading-[24px] md:text-[22px] md:leading-[26px]'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Créez votre compte et publiez votre mission rapidement</>
                                ) : (
                                    <>Créez votre compte rapidement</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-normal text-[18px] leading-[23px] text-[16px] leading-[20.83px] my-5'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Un processus d'inscription simplifié pour vous permettre de publier votre première mission en quelques minutes seulement.</>
                                ) : (
                                    <>Que vous soyez freelance ou entreprise, créez un compte en quelques minutes pour accéder à des projets ou talents qualifiés.</>
                                )
                        }
                    </div>
                </div>

                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full cat-fade-x`}>
                    <div className='w-max bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold'>O2</div>
                    <div className='font-bold text-primary-blue text-[20px] leading-[24px] md:text-[22px] md:leading-[26px]'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Accédez à des freelances qualifiés en un temps record</>
                                ) : (
                                    <>Accédez à des missions ou des talents qualifiés</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-normal text-[18px] leading-[23px] text-[16px] leading-[20.83px] my-5'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Explorez une sélection de freelances triés sur le volet, correspondant parfaitement à vos besoins. Consultez les profils, évaluez les compétences et choisissez vos talents idéaux pour démarrer sans attendre.</>
                                ) : (
                                    <>Explorez une sélection de missions ou de talents qualifiés, adaptés à vos besoins et compétences, pour des collaborations réussies.</>
                                )
                        }

                    </div>
                </div>

                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full cat-fade-x`}>
                    <div className='w-max bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold'>O3</div>
                    <div className='font-semibold text-primary-blue text-[20px] leading-[24px] md:text-[22px] md:leading-[26px]'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Suivi de projet simplifié avec gestion automatisée</>
                                ) : (
                                    <>Collaborez et gérez vos projets simplement</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-normal text-[18px] leading-[23px] text-[16px] leading-[20.83px] my-5'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Gestion de contrats, paiements sécurisés et suivi de mission – tout est géré sur notre plateforme pour vous garantir une expérience fluide.</>
                                ) : (
                                    <>Utilisez nos outils pour suivre vos projets, missions, et collaborations en toute simplicité, avec une gestion automatisée et sécurisée.</>
                                )
                        }

                    </div>
                </div>
            </div>
        </>
    );
};

const CallToAction = ({isFreelance}: any) => {
    return (
        // <div className={`${!isFreelance ? 'bg-[#F4F4F5]' : 'bg-primary-blue'} rounded-3xl flex justify-center lg:w-3/4 w-5/6 max-w-[1071px] mx-auto absolute bottom-0 left-[50%] transform translate-y-[50%] translate-x-[-50%] lg:px-[6.2em] px-[2em] py-14 lg:min-w-[900px]`}>
        <div className={`${!isFreelance ? 'bg-[#F4F4F5]' : 'bg-primary-blue'} rounded-3xl flex justify-center lg:w-3/4 w-5/6 lg:max-w-[1071px] max-w-[600px] mx-auto lg:px-[6.2em] px-[2rem] py-14 lg:min-w-[900px] mb-[140px]`}>
            <div className=" flex gap-[3em] flex-col lg:flex-row items-center justify-center">
                <div className="max-w-[500px] rounded-3xl overflow-hidden lg:w-[65rem] md:w-[500px] w-full relative lg:h-full h-[300px] bg-cover bg-norepeat bg-center lg:flex-[1]" style={{ backgroundImage: `url('/about-images/about-03.webp')` }}>
                </div>
                <div className={`space-y-3 ${!isFreelance ? '' : 'text-white'} flex flex-col justify-between lg:flex-[1.3] lg:max-w-[unset] max-w-[500px] mx-auto`}>
                    <div className="relative">
                        <div className="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 md:text-[30px] md:leading-[36px] text-[18px] leading-[21px] font-semibold cat-fade-y">
                            {
                                isFreelance ? 'Vous êtes une entreprise ?' : 'Vous êtes un freelance ?'
                            }
                        </div>
                    </div>
                    <div className="font-semibold md:text-[35px] md:leading-[42px] text-[25px] leading-[30px] cat-fade-y">
                        {
                            isFreelance ?
                                'Confiez votre projet à Wall of Share ! ' :
                                'Mettez en valeur vos compétences !'
                        }

                    </div>
                    <div className="text-[#ddddf499] font-normal text-md w-10/12 font-dm-sans cat-fade-y">
                        {
                            isFreelance ? 'Avec Wall of Share, rencontrez le talent qui correspond exactement à votre besoin. Simplifiez votre processus de recrutement et accédez rapidement à des experts prêts à relever vos défis.' :
                                "Rejoignez une communauté d'experts et accédez à des projets qui correspondent à vos compétences. Avec Wall of Share, valorisez votre expertise et trouvez des missions qui vous stimulent."
                        }
                    </div>

                    <div className="pt-1 cat-fade-y">
                        <RoundBluePlain text="Trouver un freelance" isButton={false} to="/plateforme-freelance" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />
                    </div>
                </div>
            </div>
        </div>
    );
}